 export const environment = {
production:false,
apiUrl:'http://api.gbet-un.fr/api' 

}; 
// export const environment = {
//   production: false,
//   apiUrl: '/api'      // ← يجب أن تكون هكذا بالضبط
// };